export function makeCancelable(promise: Promise<any>) {
    let isCanceled = false;
    const cPromise =
        new Promise((resolve, reject) => {
            promise
                .then((val) => (isCanceled ? reject({ reason: 'cancel' }) : resolve(val)))
                .catch((error) => (isCanceled ? reject({ reason: 'cancel' }) : reject(error)));
        });
    return {
        promise: cPromise,
        cancel() {
            isCanceled = true;
        },
    };
}